<ng-container *ngIf="isURKidsCardSubscribed">
  <h2 class="rs-tit3">{{ 'common.options' | translate }}</h2>
  <p>{{ 'kidsCard.noOptionAvailableContent' | translate }}</p>
</ng-container>
<ng-container *ngIf="!isURKidsCardSubscribed">
  <mprd-available-options-skeleton *ngIf="!availableOptionsLoaded && !hasError"></mprd-available-options-skeleton>
  <span *ngIf="availableOptionsLoaded || hasError">
    <h2 class="rs-tit3">{{ 'common.options' | translate }}</h2>
    <px-alert [alerts]="[
      {
        type: 'error',
        title: 'mobile.options.error.title' | translate,
        description: 'mobile.options.error.message' | translate,
        isClosable: false,
        taggingErrorType: 'backend'
      }
    ]" *ngIf="!availableOptionsLoaded && hasError"></px-alert>
    <ng-container *ngIf="availableOptionsLoaded">
      <div class="panel rs-bg-grey1" *ngFor="let category of categories">
        <h3 class="rs-tit6 rs-txt-c1 small-only-text-center">
          {{ category.name }}
        </h3>
        <div class="rs-flex-row">
          <mprd-option class="rs-flex-columns small-12 medium-6" *ngFor="
            let option of selectedProduct?.options
              | excludeFavAppOption
              | filterByOptionCategory: category.id
          " [product]="selectedProduct" [option]="option" data-cy="option"></mprd-option>
          <mprd-option class="rs-flex-columns small-12 medium-6" *ngFor="
            let option of selectedProduct?.configurableOptions
              | excludeFavAppOption
              | filterByOptionCategory: category.id
          " [product]="selectedProduct" [option]="option" [isConfigurableOption]="true"></mprd-option>
        </div>
      </div>
    </ng-container>
    <small class="rs-txt-s2 rs-block">{{ 'common.options.priceMention' | translate }}</small>

    <div class="rs-me"></div>
  </span>
</ng-container>